module.exports = __webpack_public_path__ + "static/media/thum1.038fb247.jpg";